export default class Cart {
    constructor() {
        this.items = new Map();
        console.log('new Cart()...')
    }

    get cartItems() {
        return this.items.values();
    }

    get totalPrice() {
        var sum = 0
        for (var type of this.items.keys()) {
            sum = sum + this.getTotalPriceByType(type)
        }
        return sum
    }

    addItem(item, qty) {
        this.items.set(item.type, { id: item.id, name: item.name, type: item.type, price: item.price, qty: qty })
    }

    getByType(type) {
        return this.items.get(type)
    }

    getTotalPriceByType(type) {
        const item = this.items.get(type)
        if (item)
            return item.qty * item.price
        else
            return 0
    }

    setQuantity(type, qty) {
        var item = this.items.get(type)
        if (item)
            item.qty = qty
        if (qty == 0)
            this.items.delete(type)
    }

    setPrice(type, price) {
        var item = this.items.get(type)
        if (item)
            item.price = price
    }
}